import React from "react";
import { Paper, ActionIcon } from "@mantine/core";
import { X } from "tabler-icons-react";
import { useIntl } from "react-intl";
import Chat from "./Chat";
import { UserType } from "../utils/types";

interface NavBarSideDrawerProps {
  toggleChatForm: boolean;
  toUser: UserType;
  onClose: () => void;
}

export default function ChatWindow(props: NavBarSideDrawerProps) {
  const intl = useIntl();

  return (
    <Paper
      className="chat-window"
      shadow="lg"
      p="md"
      style={{
        bottom: 20,
        right: 20,
      }}
    >
      <ActionIcon
        variant="transparent"
        onClick={props.onClose}
        style={{ position: "absolute", top: 10, right: 10 }}
      >
        <X size={18} />
      </ActionIcon>
      <p className="chat-window-header">
        {intl.formatMessage({ id: "chatwindow.header" })} {props.toUser?.name}
      </p>
      {/* <Textarea placeholder="Message" autosize minRows={4} />
          <Button style={{ marginTop: "10px" }} onClick={toggleChatForm}>
            Send
          </Button> */}
      <Chat toUser={props.toUser} />
    </Paper>
  );
}
